import script from "./UsuarioProximaReservasModificar.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioProximaReservasModificar.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioProximaReservasModificar.vue?vue&type=style&index=0&id=ea5dcf28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea5dcf28"]])

export default __exports__